import { EnqueueSnackbar } from "notistack";

export function csvToTextJson(csvContent: string): string {
  const rows = csvContent.split("\n");
  const headers = rows[0].split(";");

  const json: any = {};
  for (const header of headers) {
    json[header] = [];
  }

  for (let i = 1; i < rows.length; i++) {
    const rowData = rows[i].split(";");

    for (let j = 0; j < headers.length; j++) {
      if (rowData[j] !== "" && rowData[j] !== "") {
        json[headers[j]].push(rowData[j]);
      }
    }
  }

  return JSON.stringify(json);
}

export function handleUploadedSkills(
  input: HTMLInputElement,
  setUploadedSkills: any,
  enqueueSnackbar: EnqueueSnackbar
) {
  input.onchange = function (e) {
    const fileInput = e.target as HTMLInputElement;
    if (fileInput && fileInput.files) {
      const file = fileInput.files[0];
      if (file) {
        if (!validateFileType(file, enqueueSnackbar)) {
          return;
        }

        const reader = new FileReader();

        reader.onload = function () {
          const text = reader.result as string;

          setUploadedSkills(csvToTextJson(text));
          enqueueSnackbar("Competências carregadas com êxito", {
            variant: "success",
          });
          console.log(csvToTextJson(text));
        };

        reader.readAsText(file);
      } else {
        console.error("No file selected");
        enqueueSnackbar("Erro ao carregar as competências", {
          variant: "error",
        });
      }
    }
  };
}

export function validateFileType(file: File, enqueueSnackbar: EnqueueSnackbar) {
  const allowedTypes = ["text/csv", "application/vnd.ms-excel"];
  if (!allowedTypes.includes(file.type)) {
    enqueueSnackbar(
      "o tipo de arquivo não é suportado! favor utilizar o template de CSV disponibilizado!",
      {
        variant: "error",
      }
    );
    return false;
  }
  return true;
}

export function handleUploadedfeedbacks(
  input: HTMLInputElement,
  setUploadedFeedback: any,
  enqueueSnackbar: EnqueueSnackbar
) {
  input.onchange = function (e) {
    const fileInput = e.target as HTMLInputElement;
    if (fileInput && fileInput.files) {
      const file = fileInput.files[0];
      if (file) {
        if (!validateFileType(file, enqueueSnackbar)) {
          return;
        }

        const reader = new FileReader();

        reader.onload = function () {
          const text = reader.result as string;
          setUploadedFeedback(csvToTextJson(text));
          enqueueSnackbar("Feedback carregados com êxito", {
            variant: "success",
          });
          console.log(csvToTextJson(text));
        };

        reader.readAsText(file);
      } else {
        console.error("No file selected");
        enqueueSnackbar("Erro ao carregar o feedback", {
          variant: "error",
        });
      }
    }
  };
}

export function clearAll(): void {
  window.location.reload();
}
